import React from 'react';

const VideoPlayer: React.FC<{
  src: string;
  className?: string;
}> = ({ src, className = "" }) => {
  return (
    <video 
      className={`video-player ${className}`}
      controls 
      playsInline 
      loop
      preload="metadata"
      // This tells the browser to use the first frame as the poster
      onLoadedMetadata={(e) => {
        const video = e.currentTarget;
        if (!video.poster) {
          video.currentTime = 0.1;
          // After a brief moment, reset to start
          setTimeout(() => {
            video.currentTime = 0;
          }, 150);
        }
      }}
    >
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;